import type { ReactElement } from 'react';
import { AnalyzingIndicator } from './AnalyzingIndicator';

type AnalyzingStepProps = {
  thinking: string;
};

export function AnalyzingStep({ thinking }: AnalyzingStepProps): ReactElement {
  return (
    <section className="flex flex-col items-center justify-center gap-4 py-16">
      <AnalyzingIndicator label="CSV を解析しています" />
      <p className="text-xs text-muted-light">数十秒 ~ 数分程度かかる場合があります。</p>
      {thinking ? (
        <details className="w-full max-w-2xl rounded-md border border-default bg-subtle-light px-3 py-2" open>
          <summary className="cursor-pointer text-xs font-medium text-muted-light">途中経過</summary>
          <pre className="mt-2 max-h-64 overflow-auto whitespace-pre-wrap text-xs text-muted-light">{thinking}</pre>
        </details>
      ) : null}
    </section>
  );
}
